import api from '@/api/management/officer'

export default {
  state: {
    officers: []
  },
  mutations: {
    setOfficers(state, value) {
      state.officers = value
    }
  },
  actions: {
    getOfficers({commit}, params = {}) {
      return api.getMany(params)
        .then(i => {
          commit('setOfficers', i.data.data)
          return i
        })
        .catch(i => i)
    }
  },
  getters: {
    officers: state => state.officers || []
  },
  namespaced: true
}
